import CyesaOrderHeadingRowConfig from '../cyesa/orders-heading-row'
import DefaultOrderHeadingRowConfig from '../default/orders-heading-row'
import webshopName from '../common/webshop-name'

const orderHeadingModuleConfig = webshopName === 'cyesa-com' ? CyesaOrderHeadingRowConfig : DefaultOrderHeadingRowConfig

export default orderHeadingModuleConfig
